export function checkPeriodCoverage(startDateTime, endDateTime, deviceDate) {
    if (startDateTime && deviceDate < startDateTime) {
        return '`startDateTime` > device `dateTime`';
    }
    if (endDateTime && endDateTime <= deviceDate) {
        return '`endDateTime` <= device `dateTime`';
    }
    return null;
}
